<div class="steam-inventory-content">
  <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

  <ng-container *ngIf="kits">
    <span>Кол-во kits: {{ kits.count }}</span>
    <mat-divider class="divider"></mat-divider>
    <div class="steam-inventory-container">
      <div class="kit-container" *ngFor="let kit of kits.kits">
        <div class="kit-info-container">
          <div class="kit-info-item">
            <span class="description">id: </span>
            <span>{{ kit.id }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">status: </span>
            <span>{{ kit.status }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">price: </span>
            <span matTooltip="{{kit.price  | fastCoinsToDollar}}"
                  matTooltipPosition="above">{{ kit.price / 100 | customCurrency }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">seller price: </span>
            <span
              matTooltip="{{kit.sellerPrice  | fastCoinsToDollar}}">{{ kit.sellerPrice / 100 | customCurrency }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">recommended price: </span>
            <span
              matTooltip="{{kit.recommendedPrice  | fastCoinsToDollar}}">{{ kit.recommendedPrice / 100 | customCurrency }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">express: </span>
            <span>{{ kit.express }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">status at: </span>
            <span>{{ kit.statusAt | date: 'dd.MM.yy HH:mm' }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">next status at: </span>
            <span>{{ kit.nextStatusAt | date: 'dd.MM.yy HH:mm' }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">next bid price: </span>
            <span
              matTooltip="{{kit.nextBidPrice  | fastCoinsToDollar}}">{{ kit.nextBidPrice / 100 | customCurrency }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">next seller price: </span>
            <span
              matTooltip="{{kit.nextSellerPrice  | fastCoinsToDollar}}">{{ kit.nextSellerPrice / 100 | customCurrency }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">is user seller: </span>
            <span>{{ kit.isUserSeller }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">is last bid By User: </span>
            <span>{{ kit.isLastBidByUser }}</span>
          </div>

          <div class="kit-info-item">
            <span class="description">order: </span>
            <span>{{ kit.order || 'N/A' }}</span>
          </div>

        </div>
        <div class="kit-items-container">
          <app-market-item *ngFor="let item of kit.items"
                           [name]="item.baseItem.shortName || item.baseItem.name"
                           [weapon]="item.baseItem.icon"
                           [price]="item.price"
                           [recommendedPrice]="item.recommendedPrice"
                           [sellerPrice]="item.sellerPrice"
                           [color]="item.baseItem.color"
                           [exterior]="item.baseItem.exterior"
                           [skin]="item.baseItem.skin"
                           [nextStatusAt]="item.nextStatusAt"
                           [phase]="item.phase"
                           [statTrak]="item.baseItem.statTrak">
          </app-market-item>
        </div>
      </div>
    </div>
    <p *ngIf="!kits.kits?.length" class="empty-data">Предметов нет</p>

    <mat-paginator #paginator
                   [length]="kits.count"
                   [pageIndex]="currentPage"
                   [pageSize]="pageSize"
                   [pageSizeOptions]="pageSizeOptions"
                   (page)="pageChanged($event)"
                   aria-label="Select page">
    </mat-paginator>
  </ng-container>
</div>
